import { useState } from 'react';
import { t } from '../i18n';

/** Schreibgeschütztes Feld mit Kopierknopf (Links für Spieler). */
export function CopyField({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <span className="row">
      <input readOnly value={value} onFocus={(e) => e.target.select()} className="screen-link" />
      <button
        type="button"
        onClick={() =>
          void navigator.clipboard.writeText(value).then(() => {
            setCopied(true);
            window.setTimeout(() => setCopied(false), 2000);
          })
        }
      >
        {copied ? t('screen.copied') : t('screen.copy')}
      </button>
    </span>
  );
}
